import React from 'react';
import SideNav from './SideNav/';
import Dashboard from './Dashboard';

import Login from './Login/';
import ResetPwd from './ResetPwd/';
import UpdatePwd from './UpdatePwd/';
import VoiceMailCampaign from './VoiceMailCampaign/';

import UserManagement from './UserManagement';
import UserProfile from './UserManagement/UserProfile';
import CreateUser from './UserManagement/CreateUser';
import CreateTrunk from './TrunkManagement/CreateTrunk';
import CreateDialer from './DialerManagement/CreateDialer';
import CLIManagement from './CLIManagement';
import DialerManagement from './DialerManagement';
import TrunkManagement from './TrunkManagement';
import AddCLI from './CLIManagement/AddCLI';
import UpdateUser from './UserManagement/UpdateUser';
import UpdateCli from './CLIManagement/UpdateCLI';
import UpdateDialer from './DialerManagement/UpdateDialer';
import UpdateTrunk from './TrunkManagement/UpdateTrunk';
import AllocateCli from './CLIManagement/AllocateCLI';
import ArchivedCli from './CLIManagement/ArchivedCLI';
import Report from './Report';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import UploadCLIFile from './CLIManagement/UploadCLIFile';
import { createBrowserHistory } from 'history';
import UploadCLIApiFile from './ApiCliManagement/UploadCLIFile';
import ApiCLIManagement from './ApiCliManagement';

const Body = (props) => {
	const app = props.app;
	// Get the current location.
	const history = createBrowserHistory();
	const location = history.location;
	let homePage = '';
	
	if ((app.userId === '' || typeof app.userId === 'undefined' || app.token === '' || typeof app.token === 'undefined')) {
		if ( location.pathname === '/reset-pwd' ) {
			homePage = <ResetPwd setUserToken={props.setUserToken} app={app} />;
		}
		else if ( location.pathname.includes( '/update-pwd' ) ){
			homePage = <Switch><Route exact path="/update-pwd/:selectedToken" render={(routeprops) => (
				<UpdatePwd selectedToken={routeprops.match.params.selectedToken} app={props.app} {...routeprops} />)
			} />
			</Switch>
		}
		else
		{
			homePage = <Login setUserToken={props.setUserToken} app={app} />;
		}
	} else {
		let sideNav = '';
		sideNav = <SideNav toggleSidebar={props.toggleSidebar} app={app} />;

		homePage = <div className="app-body">
			{sideNav}
			<main className="main">
				<div className="container-fluid">
					<VoiceMailCampaign app={app} />
					<Switch>
						<Route exact path="/"><Dashboard app={app} /></Route>
						<Route path="/user-list"><UserManagement app={app} /></Route>
						<Route path="/user-profile"><UserProfile app={app} /></Route>
						<Route path="/trunk-list"><TrunkManagement app={app} /></Route>
						<Route path="/dialer-list"><DialerManagement app={app} /></Route>
						<Route exact path="/update-user/:selectedUserId" render={(routeprops) => (
							<UpdateUser selectedUserId={routeprops.match.params.selectedUserId} app={props.app} {...routeprops} />)
						} />
						<Route path="/create-user"><CreateUser app={app} /></Route>
						<Route path="/create-dialer"><CreateDialer app={app} /></Route>
						<Route path="/create-trunk"><CreateTrunk app={app} /></Route>
						
						<Route path="/report"><Report app={app} /></Route>
						
						<Route exact path="/update-cli/:selectedCliId" render={(routeprops) => (
							<UpdateCli selectedCliId={routeprops.match.params.selectedCliId} app={props.app} {...routeprops} />)
						} />
						<Route exact path="/update-dialer/:selectedDialerId" render={(routeprops) => (
							<UpdateDialer selectedDialerId={routeprops.match.params.selectedDialerId} app={props.app} {...routeprops} />)
						} />
						<Route exact path="/update-trunk/:selectedTrunkId" render={(routeprops) => (
							<UpdateTrunk selectedTrunkId={routeprops.match.params.selectedTrunkId} app={props.app} {...routeprops} />)
						} />
						<Route path="/allocate-cli"><AllocateCli app={props.app} /></Route>
						<Route path="/download-report"><Report app={app} /></Route>
						<Route path="/upload-cli"><UploadCLIApiFile app={props.app} /></Route>
						<Route path="/cli-list"><ApiCLIManagement app={app} /></Route>

					</Switch>

				</div>
			</main>
		</div>;
	}
	return (
		<Router>
			{homePage}
		</Router>
	);
}

export default Body;
